import { Avatar, Button, Dialog, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { deleteMyProfile, getMyPosts, logoutUser } from "../../Actions/User";
import Loader from "../Loader/Loader";
import Post from "../Post/Post";
import User from "../User/User";
import "./Account.css";

const Account = () => {
    const dispatch = useDispatch();

    const { user, loading: userLoading } = useSelector((state) => state.user);
    const { loading, error, posts } = useSelector((state) => state.myPosts);
    const {
        error: likeError,
        message,
        loading: deleteLoading,
    } = useSelector((state) => state.like);

    const [followersToggle, setFollowersToggle] = useState(false);

    const [followingToggle, setFollowingToggle] = useState(false);

    const logoutHandler = () => {
        dispatch(logoutUser());
        toast.warn("Logged out successfully");
    };

    useEffect(() => {
        dispatch(getMyPosts());
    }, [dispatch]);

    const deleteProfileHandler = async () => {
        await dispatch(deleteMyProfile());
        dispatch(logoutUser());
    };

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch({ type: "clearErrors" });
        }

        if (likeError) {
            toast.error(likeError);
            dispatch({ type: "clearErrors" });
        }

        if (message) {
            toast.success(message);
            dispatch({ type: "clearMessage" });
        }
    }, [error, message, likeError, dispatch]);

    return loading === true || userLoading === true ? (
        <Loader />
    ) : (
        <div className="account">
            <div className="accountleft">
                {posts && posts.length > 0 ? (
                    posts.map((post) => (
                        <Post
                            key={post._id}
                            postId={post._id}
                            caption={post.caption}
                            postImage={post.image.url}
                            likes={post.likes}
                            comments={post.comments}
                            ownerImage={post.owner.avatar.url}
                            ownerName={post.owner.name}
                            ownerId={post.owner._id}
                            isAccount={true}
                            isDelete={true}
                        />
                    ))
                ) : (
                    <Typography variant="h6">
                        You have not made any post
                    </Typography>
                )}
            </div>
            <div className="accountright">
                <Avatar
                    src={user.avatar.url}
                    sx={{ height: "8vmax", width: "8vmax" }}
                />

                <Typography variant="h5">{user.name}</Typography>

                <div>
                    <button
                        onClick={() => setFollowersToggle(!followersToggle)}
                    >
                        <Typography>Followers</Typography>
                    </button>
                    <Typography>{user.followers.length}</Typography>
                </div>

                <div>
                    <button
                        onClick={() => setFollowingToggle(!followingToggle)}
                    >
                        <Typography>Following</Typography>
                    </button>
                    <Typography>{user.following.length}</Typography>
                </div>

                <div>
                    <Typography>Posts</Typography>
                    <Typography>{user.posts.length}</Typography>
                </div>

                <Button variant="contained" onClick={logoutHandler}>
                    Logout
                </Button>

                <Link to="/update/profile">Edit Profile</Link>
                <Link to="/update/password">Change Password</Link>

                <Button
                    disabled={deleteLoading}
                    onClick={deleteProfileHandler}
                    variant="text"
                    style={{ color: "red", margin: "2vmax" }}
                >
                    Delete My Profile
                </Button>

                <Dialog
                    open={followersToggle}
                    onClose={() => setFollowersToggle(!followersToggle)}
                >
                    <div className="DialogBox">
                        <Typography variant="h4">Followers</Typography>

                        {user && user.followers.length > 0 ? (
                            user.followers.map((follower) => (
                                <User
                                    key={follower._id}
                                    userId={follower._id}
                                    name={follower.name}
                                    avatar={follower.avatar.url}
                                />
                            ))
                        ) : (
                            <Typography style={{ margin: "2vmax" }}>
                                You have no followers
                            </Typography>
                        )}
                    </div>
                </Dialog>

                <Dialog
                    open={followingToggle}
                    onClose={() => setFollowingToggle(!followingToggle)}
                >
                    <div className="DialogBox">
                        <Typography variant="h4">Following</Typography>

                        {user && user.following.length > 0 ? (
                            user.following.map((follow) => (
                                <User
                                    key={follow._id}
                                    userId={follow._id}
                                    name={follow.name}
                                    avatar={follow.avatar.url}
                                />
                            ))
                        ) : (
                            <Typography style={{ margin: "2vmax" }}>
                                You're not following anyone
                            </Typography>
                        )}
                    </div>
                </Dialog>
            </div>
        </div>
    );
};

export default Account;
